import React from "react";
import "./ConstruccionCivil.css"; // Reutilizamos el mismo estilo
import contabilidadImg from "../assets/images/contabilidad.jpg";
import pdfMalla from "../assets/docs/contabilidad.pdf";
import { FaDownload, FaCalculator } from "react-icons/fa";

const Contabilidad = () => {
  return (
    <section className="carrera-detalle">
      {/*  Banner superior */}
      <div className="carrera-hero-modern" style={{ backgroundImage: `url(${contabilidadImg})` }}>
        <div className="carrera-hero-overlay">
          <h1 className="fw-bold">Contabilidad</h1>
          <p>Formamos profesionales técnicos en gestión contable, financiera y tributaria.</p>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="container my-5">
        <div className="row g-4">
          {/*  Información principal */}
          <div className="col-lg-8">
            <div className="info-card p-4 shadow-sm rounded-4 bg-white">
              <h3 className="text-primary fw-bold mb-3">
                <FaCalculator className="me-2" />
                TÍTULO: PROFESIONAL TÉCNICO EN CONTABILIDAD
              </h3>

              <h5 className="fw-bold text-primary mt-4">DESCRIPCIÓN DEL PERFIL DE EGRESO</h5>
              <p>
                El profesional técnico del programa de estudios de Contabilidad del Instituto de Educación Superior Tecnológico Público
                “Gilda Liliana Ballivián Rosado”, tiene competencias para desarrollar y supervisar las operaciones contables y financieras;
                para formular los estados financieros y actualizar los procedimientos contables y financieros; según políticas, procedimientos y normativa correspondiente.
              </p>
              <p>
                También está capacitado para desempeñarse de manera ética e integrarse al entorno laboral mediante una comunicación efectiva,
                tanto en nuestro idioma oficial como en inglés; asimismo, emplea adecuadamente las tecnologías de la información,
                realiza emprendimiento empresarial, promueve una cultura ambiental y busca la solución de problemas con liderazgo, innovación y trabajo colaborativo,
                tanto en organizaciones públicas como privadas.
              </p>

              <h5 className="fw-bold text-primary mt-4">COMPETENCIA GENERAL</h5>
              <p>
                Planifica, organiza, verifica y registra las operaciones económicas y financieras de las entidades públicas y privadas en función de su actividad,
                de acuerdo al sistema de contabilidad y la legislación vigente.
              </p>

              <h5 className="fw-bold text-primary mt-4">COMPETENCIAS ESPECÍFICAS</h5>
              <ul>
                <li>Desarrollar las operaciones de contabilidad y finanzas según políticas y normativa vigente.</li>
                <li>Supervisar las operaciones contables y financieras conforme a los procedimientos institucionales.</li>
                <li>Formular los estados financieros de la organización según normas y políticas establecidas.</li>
                <li>Actualizar los procedimientos contables y financieros conforme a la normativa correspondiente.</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">CAMPOS DE ACCIÓN</h5>
              <p>
                El profesional técnico en Contabilidad se desempeñará en el mercado laboral peruano en los sectores productivos,
                tanto en empresas privadas como instituciones públicas relacionadas con la administración y el comercio.
                Asimismo, podrá generar su propia empresa.
              </p>
              <ul>
                <li>Gerente de micro y pequeña empresa</li>
                <li>Asesor contable de pequeñas y microempresas</li>
                <li>Analista de costos y finanzas</li>
                <li>Asistente contable</li>
                <li>Jefe de área contable</li>
                <li>Docente en contabilidad</li>
              </ul>
            </div>
          </div>

          {/*  Panel lateral */}
          <div className="col-lg-4">
            <div className="sidebar-card p-4 rounded-4 shadow-sm text-center bg-white">
              <img src={contabilidadImg} alt="Contabilidad" className="img-fluid rounded-3 mb-3" />
              <a href={pdfMalla} target="_blank" rel="noopener noreferrer" className="btn btn-download w-100">
                <FaDownload className="me-2" /> Descargar Malla Curricular 2024 (PDF)
              </a>
              <div className="mt-4 text-start">
                <h6 className="text-primary fw-bold">DURACIÓN</h6>
                <p className="mb-2">6 semestres equivalentes a 3 años académicos.</p>
                <h6 className="text-primary fw-bold">TURNOS DE ESTUDIO</h6>
                <p className="mb-0">Diurno: 8:00 a.m. a 1:00 p.m.</p>
                <p className="mb-0">Nocturno: 6:00 p.m. a 10:20 p.m.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contabilidad;

